import React from 'react';
import './style.css'
import QRCode from "react-qr-code";
import { useSelector } from 'react-redux';
import { store } from '../../../redux/store';
import { setGoHome } from '../../../redux/slices/initLoad/types';
import ChangeLang from '../../../components/changeLang';
import { useTranslation } from 'react-i18next';

const Index = ({ showBack = true, showFlame=true,showCocktails = false,showEvents = false,showImageTop = true, showLamp = true,children, showLogo=true, showLang=true, showFooter=true, setShowListProduct, setShowSpecials, goHome, goCategories }) => {
   
  const [showModal, setShowModal] = React.useState(false);
  const [showBoost, setshowBoost] = React.useState(false);
  const [showModalPincode, setShowModalPincode] = React.useState(false);
  const [secret, setScret] = React.useState("");


   const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

  
  

  const footerIconStyle = { width: 'clamp(24px, 3.6vw, 44px)', height: 'clamp(24px, 3.6vw, 44px)' };
  const footerLabelStyle = {
    fontFamily: "'Bebas Neue', 'Futura-CondensedExtraBold', 'AvenirNextCondensed-Heavy', Impact, 'Arial Narrow', sans-serif",
    fontWeight: 900,
    fontSize: 'clamp(26px, 4.6vw, 56px)',
    lineHeight: 1,
    textTransform: 'uppercase'
  };
  const footerDividerStyle = { width: 2, alignSelf: 'stretch', margin: '12px 0', background: '#000' };

  const handleButtonClick = () => {
    if (setShowListProduct) {
      setShowListProduct(false); 
    }
  };
  


   const {
      goHomeInit
   } = useSelector((state) => state.initLoad);


  const validScret = () => {

    if (secret === '') {
      alert('Debe ingresar el pin')
    }

    if (secret === "2355") {
       window.location.reload();
    } else {
       alert('Code invalid')
    }
    
  }
  
    return (
      <div className='backgroundlayout' style={{
        flex: 1,
        backgroundSize: 'cover',
        width: '100%',
        height: '100vh',
       
      }}>

        
        <div>
          {/*<button onClick={()=>setOpenNav(!openNav)} style={{...styles.iconMenuMobile, ...iconMenu}}>
            <Menu />
          </button>*/}
          

          <div className='contentChild' >
               

            <div className='nav-menu-bar' style={{
              marginTop:  0,
              width: '100%',
              position: 'relative'
            
            }}>

             
              {showLogo &&
              <div style={{
               
                paddingTop: 20,
                paddingBottom: 20,
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: showBack ? 'space-between':'center',
            
                }}>
                  
                  <div style={{ display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',}}>
                     {showBack && (
                        <button
                            onClick={()=>handleButtonClick()}
                            style={{
                              height: 50,
                              width: 120,
                                paddingLeft: 16,
                                paddingRight: 16,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                marginLeft: 15,
                                zIndex: 999,
                                position: 'relative',
                                borderRadius: 8,
                                border: '2px solid #fff',
                                backgroundColor: 'red',
                                color: '#fff',
                                fontSize: 14,
                                fontWeight: 'bold',
                            }}>
                           {langEng? "← Go Back": "← Volver"} 
                        </button>
                    )}

                  </div>
                  
                  <div style={{
                      alignItems: 'center',}}   >
                       <div style={{
                      
                        display: 'flex',
                          alignItems: 'center',
                              position: 'relative',
                              zIndex: 999,
                              justifyContent: 'end',}}>
                        {/* <div onClick={()=>setShowModal('https://www.instagram.com/colombiansteakhouse/')} target='_blank'> <img
                        style={{
                          width: 28,
                            height: 28,
                            marginInline: 10
                        
                      }}
                      src={require('./assets/instagram.png')}
                      alt="Logo"
                      /> 
                      </div> */}

                      {/* <div target='_blank' onClick={()=>setShowModal('https://www.facebook.com/colombianNJ/photos')}> 
                        <img
                          style={{
                              width: 28,
                                height: 28,
                                marginInline: 10
                        }}
                          src={require('./assets/facebook.png')}
                          alt="Logo"
                        /> 
                      </div> */}

                  
                    <div>
                    {/* <ChangeLang /> */}
                    </div>
                      </div>
                  </div>

                 
              </div>
              }
              


               {showLang && <div style={{
                          position: 'absolute',
                right: 20,
                zIndex: 1000,
                          top: showBack ? 20: 40
                        }}>
                           <ChangeLang />
                   </div>}
            

            </div>
            {children}

            
            {showFooter &&
            <div
            style={{
              position: 'absolute',
              bottom: 0,
                  alignSelf: 'center',
                
                  width: '100%',
                  left: 0,
                  zIndex: 999
                
              
            }}>
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: 6,
                    marginBottom: 4,
                 
                   
              }}
            >
              <div
                style={{
                  width: '84%',
                  maxWidth: 1180,
                  minHeight: 'clamp(56px, 8vw, 100px)',
                  background: '#FFF200',
                  borderRadius: 999,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-around',
                  paddingInline: 34,
                  color: '#000',
                  boxSizing: 'border-box',
                  
                  boxShadow: '0 6px 14px rgba(0, 0, 0, 0.28)'
                }}
              >
                <div
                  onClick={() => {
                    handleButtonClick();
                    store.dispatch(setGoHome(!goHomeInit));
                    if (goHome) {
                      goHome();
                    }
                  }}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    color: '#000',
                    cursor: 'pointer',
                    userSelect: 'none',
                  }}
                >
                  <svg viewBox="0 0 24 24" style={footerIconStyle}><path fill="currentColor" d="M12 2.5 1.5 11.2l1.4 1.6L4 11.9V21h6v-6h4v6h6v-9.1l1.1.9 1.4-1.6z"/></svg>
                  <span style={footerLabelStyle}>Home</span>
                  {/* <p
                    style={{
                      color: '#fff',
                      margin: 0,
                      fontSize: 22,
                      fontWeight: '800',
                      textTransform: 'uppercase',
                      letterSpacing: 0.6,
                      fontFamily: "'Times New Roman', serif"
                    }}
                  >
                    Home
                  </p> */}
                </div>

                <div style={footerDividerStyle} />

                <div
                  onClick={() => {
                        if (goCategories) {
                      goCategories();
                    }
                  }}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    color: '#000',
                    cursor: 'pointer',
                    userSelect: 'none'
                  }}
                >
                  <svg viewBox="0 0 24 24" style={footerIconStyle}><path fill="currentColor" d="M15.5 1 14 6H5l1.6 16h10.8L19 6h-3l1.4-4.4zM7.2 8h9.6l-.4 4H7.6z"/></svg>
                  <span style={footerLabelStyle}>{langEng ? 'Drinks' : 'Bebidas'}</span>
                  {/* <
                    style={{
                      color: '#fff',
                      margin: 0,
                      fontSize: 22,
                      fontWeight: '800',
                      textTransform: 'uppercase',
                      letterSpacing: 0.6,
                      fontFamily: "'Times New Roman', serif"
                    }}
                  >
                    {langEng ? 'Drinks' : 'Bebidas'}
                  </p> */}
                </div>

                <div style={footerDividerStyle} />

                <div
                  onClick={() => {
                    if (setShowSpecials) {
                     // setShowSpecials(true);
                    }
                  }}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    color: '#000',
                    cursor: 'pointer',
                    userSelect: 'none'
                  }}
                >
                  <svg viewBox="0 0 24 24" style={footerIconStyle}><circle cx="12" cy="12" r="11" fill="currentColor"/><path d="m8 16 8-8" stroke="#FFF200" strokeWidth="2" strokeLinecap="round"/><circle cx="8.5" cy="8.5" r="1.6" fill="#FFF200"/><circle cx="15.5" cy="15.5" r="1.6" fill="#FFF200"/></svg>
                  <span style={footerLabelStyle}>{langEng ? 'Specials' : 'Especiales'}</span>
                  {/* <p
                    style={{
                      color: '#fff',
                      margin: 0,
                      fontSize: 22,
                      fontWeight: '800',
                      textTransform: 'uppercase',
                      letterSpacing: 0.6,
                      fontFamily: "'Times New Roman', serif"
                    }}
                  >
                    {langEng ? 'Especials' : 'Especiales'}
                  </p> */}
                </div>
              </div>
            </div>
                

<div
              style={{
                zIndex: 100,
                flexDirection: 'row',
                justifyContent: 'space-around',
                paddingHorizontal: 20,
                paddingVertical: 5,
                  alignItems: 'center',
               
              }}>
                  <div
                    onClick={()=> setshowBoost(true)}
                    style={{ flexDirection: 'row', alignItems: 'center', width: '80%', margin: '0 auto' }}>
                    <p style={{color: '#000', fontWeight: '900', textAlign: 'center', fontSize: 9}}>
                      "PLEASE INFORM THE WAITER IF YOU HAVE ANY TYPE OF ALLERGIC CONDITION. PARTIES OF 5+ ARE SUBJECT TO AN AUTOMATIC 20% GRATUITY. A 3% SURCHARGE WILL BE ADDED TO ALL CREDIT CARD TRANSACTIONS."
                    </p>
                <p
                  style={{
                      color: '#000',
                      fontWeight: '300',
                      textAlign: 'center',
                      fontSize: 14,
                    }}>
                 Powered by boostyourmenu.com v1.3
                </p>
              </div>
            </div>


          </div>
            }
            
            {showBoost &&
              <div onClick={ ()=> setshowBoost(false)} style={{ position: 'absolute', top: 0, bottom: 0, left: 0, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999, flexDirection: 'column' }}>
                <img
                 
                            style={{
                              width: 500,
                                height: 500,
                                marginInline: 10,
                                objectFit: 'contain',
                                zIndex: 9999
                            
                          }}
                          src={require('./assets/boost.png')}
                          alt="Logo"
                /> 
            
            </div>
            }
            

            {showModalPincode &&
              <div style={{ position: 'absolute', top: 0, bottom: 0, left: 0, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999, flexDirection: 'column' }}>
                
                <div style={{ position: 'absolute',background: '#fff', width: 500, height: 300, borderRadius: 30, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: "column" }}>
                  <img
                      onClick={()=>setShowModalPincode(false)}
                    style={{
                      position: 'absolute',
                      top: -10,
                      
                                width: 40,
                                  height: 40,
                                  marginInline: 10,
                                  objectFit: 'contain',
                                  position: 'absolute',
                                  right: -10,
                                  zIndex: 9999
                              
                            }}
                      src={require('./assets/close.png')}
                      alt="Logo"
                  /> 
                  <h4 style={{ color: '#F40000', fontSize: 40, fontWeight: 'bold', margin: 20 }}>PIN</h4>
                  <input type='number' style={{ width: 300, height: 40 }} onChange={(e) => {
                    setScret(e.target.value)
                  }} />
                  <br /><br />
                  
                  <div style={{display: 'flex', gap: 20}}>
                    <div onClick={() => setShowModalPincode(false)} style={{background: '#FF1616', width: 150, height: 50, justifyContent: 'center', alignItems: 'center', display: 'flex', borderRadius: 7}}>
                      <p style={{color: 'white', textTransform: 'uppercase', fontWeight: 'bold'}}>atras</p>
                    </div>
                    <div onClick={()=>validScret()} style={{ background: '#FF1616', width: 150, height: 50, justifyContent: 'center', alignItems: 'center', display: 'flex', borderRadius: 7 }}>
                      <p style={{color: 'white', textTransform: 'uppercase', fontWeight: 'bold'}}>Enviar</p>
                  </div>
                </div>
                </div>
              </div>
            }

            <img
                onClick={()=>setShowModalPincode(true)}
                        style={{
                          width: 40,
                            height: 40,
                            marginInline: 10,
                            objectFit: 'contain',
                            position: 'absolute',
                            bottom: -1,
                            right: 0,
                            zIndex: 9999
                        
                      }}
                src={require('./assets/pincode.png')}
                alt="Logo"
            /> 

         


            

            

            
            {showModal &&  <div onClick={()=>setShowModal(false)} style={{position: 'absolute', top: 0, bottom: 0, left: 0,width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999}}>
              <QRCode
              size={256}
              style={{ height: 400,  width: 400 }}
              value={showModal}
              divBox={`0 0 256 256`}
            />
            </div>}
           
          </div>
        </div>
      </div>
     
    );
  };

export default Index;